<div role="status">
  <div class="mb-4" [ngSwitch]="BannerStatusToStyle[bannerStatus]" *ngIf="showBanner">
    <ng-container *ngSwitchCase="BannerStyle.info">
      <div class="info-banner alert alert-primary w-100 d-flex align-items-center">
        <ds-icon class="margin-right-sm icon-info" [icon]="Icons.CircleInfo" [iconStyle]="IconStyles.Regular"></ds-icon>
        <ng-container *ngIf="(isNewScanBannerEnabled$ | async) === false; else newScannerBanner">
          {{ BannerStatusMessage[bannerStatus] | translate }}
        </ng-container>
        <ng-container *ngTemplateOutlet="closeBannerButton"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="BannerStyle.success">
      <div class="success-banner alert alert-success w-100 d-flex align-items-center">
        <ds-icon class="margin-right-sm icon-success" [icon]="Icons.Check" [iconStyle]="IconStyles.Regular"></ds-icon>
        <ng-container *ngIf="(isNewScanBannerEnabled$ | async) === false; else newScannerBanner">
          <span [innerHTML]="BannerStatusMessage[bannerStatus] | translateHtml: [taskLink, taskProjectId]"></span>
        </ng-container>
        <ng-container *ngTemplateOutlet="closeBannerButton"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="BannerStyle.error">
      <div class="error-banner alert alert-danger w-100 d-flex align-items-center">
        <ds-icon class="margin-right-sm icon-error" [icon]="Icons.TriangleExclamation" [iconStyle]="IconStyles.Regular"></ds-icon>
        <ng-container *ngIf="(isNewScanBannerEnabled$ | async) === false; else newScannerBanner">
          {{ BannerStatusMessage[bannerStatus] | translate }}
        </ng-container>
        <ng-container *ngTemplateOutlet="closeBannerButton"></ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #newScannerBanner>
  <ng-container *ngIf="bannerTextMultiLineNewFF.length === 1; else bannerTextList">
    <span data-test-id="new-banner-html" [innerHTML]="bannerHtmlNewFF"></span>
  </ng-container>
  <ng-template #bannerTextList>
    <ul>
      <li *ngFor="let line of bannerTextMultiLineNewFF">{{ line }}</li>
    </ul>
  </ng-template>
</ng-template>

<ng-template #closeBannerButton>
  <button
    ds-button
    [variant]="DsButtonVariants.microAction"
    [microActionIcon]="Icons.XMark"
    [attr.aria-label]="'label_close' | translate"
    class="ms-auto"
    (click)="closeBanner()"
  ></button>
</ng-template>
